module.exports = __webpack_public_path__ + "img/masscoms_4.dc7e4941.png";